import { userFriendsQueryOptions } from '@/api/queries/friendship';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to fetch a specific user's friends list
 */
export function useUserFriends(userId: string) {
  return useQuery(userFriendsQueryOptions(userId));
}
